import React, { Component } from 'react';


export default class GroupsViewCentral extends Component {

    constructor(props) {
        super(props);

        this.state = {
            phase: 0,
            index: 0
        }

        this.previousItem = this.previousItem.bind(this);
        this.nextItem = this.nextItem.bind(this);

        this.loopInterval = setInterval(this.nextItem, 4000);
    }

    previousItem() {
        if (this.state.phase === 0) {
            clearInterval(this.loopInterval);
            setTimeout(() => { this.loopInterval = setInterval(this.nextItem, 4000) }, 10000)
            this.setState({ phase: 1 }, () => {
                setTimeout(() => {
                    let nextIndex = this.state.index - 1;
                    if (nextIndex < 0) {
                        nextIndex = this.props.info.length - 1;
                    }
                    if (nextIndex < 0) {
                        nextIndex = 0;
                    }
                    this.setState({ phase: 0, index: nextIndex });
                }, 250);
            });
        }
    }

    nextItem() {
        if (this.state.phase === 0) {
            this.setState({ phase: 1 }, () => {
                setTimeout(() => {
                    let nextIndex = this.state.index + 1;
                    if (nextIndex >= this.props.info.length) {
                        nextIndex = 0;
                    }
                    this.setState({ phase: 0, index: nextIndex });
                }, 250);
            });
        }
    }

    render() {

        let outerStyle = {};
        if (this.props.isFloated) {
            outerStyle.float = "left";
        }

        return (
            <div className={"z-info-ticker"} style={outerStyle}>
                <div className={"material-icons ticker left"} onClick={this.previousItem}>arrow_back_ios</div>
                <div className={"material-icons ticker right"} onClick={this.nextItem}>arrow_forward_ios</div>
                <div className={"info" + (this.state.phase != 0 ? " faded" : "")} onClick={this.props.centerClick}>{
                    this.props.info.length != undefined && this.props.info.length > 0 ?
                        `${this.props.info[this.state.index].name}: ${this.props.info[this.state.index].value}` : "No Info"
                }</div>
            </div>
        );
    }
}

